import React, { useEffect, useState } from 'react'
import { createAffiliationHooks, validate } from 'pages/School/CreateAffiliation'
import { Alert } from 'components'
import { WrapCreateAffiliation, CreateAffiliationStyles } from './Style'
import { Form, RenderFields } from 'components/Form'
import { useSelector } from 'react-redux'
import { getAffiliationFetch } from 'store/middlewares/affiliation.crud'
import { useQuery } from '@tanstack/react-query'
import schoolsFile from 'mock/Schools.csv';
import Papa from 'papaparse';
import qc from 'keys/queryClient'

const Affliation = ({ props }) => {
    const [schools, setSchools] = useState(null)
    const { headerFilters } = useSelector(state => state.header)

    const submitBtns = createAffiliationHooks.useSubmitBtns()
    const { fields, contactFields, principalFields } = createAffiliationHooks.useFormFields({ schools: schools })
    const setAlert = createAffiliationHooks.useAlert()
    const createAffiliation = createAffiliationHooks.useCreateAffiliation()
    const editAffiliation = createAffiliationHooks.useEditAffiliation()

    const formName = "createAffliation"

    const affiliation = useQuery({
        queryKey: [qc.affiliation, props?.id || ""],
        queryFn: async () => {
            const { data } = await getAffiliationFetch(props?.id)
            return data
        },
        enabled: !!props?.id
    })

    useEffect(() => {
        if (!schools)
            fetch(schoolsFile)
                .then(response => response.text())
                .then(csvData => {
                    Papa.parse(csvData, {
                        header: true,
                        complete: (results) => {
                            setSchools(results.data)
                        },
                        error: (error) => {
                            console.error('CSV Parsing Error:', error);
                        }
                    });
                })
                .catch(error => {
                    console.error('Error fetching CSV file:', error);
                });
    }, [])

    const affiliationExist = props?.id

    return (
        <Alert
            width={700}
            systemUI
            title={affiliationExist ?
                `עריכת בית ספר - ${props?.name || ""}` :
                "הוספת בית ספר"}
            footerActions={submitBtns}
            handleAlert={() => setAlert(false)}
        >
            <Form
                form={formName}
                title={null}
                validations={validate}
                fields={[]}
                csswrap={WrapCreateAffiliation}
                submit={(val) =>
                    affiliationExist ?
                        editAffiliation(val) :
                        createAffiliation(val)}
                initialValues={affiliation.data || {}}
            >
                <CreateAffiliationStyles>
                    <div className='section-title'></div>
                    <div className='section-fields'>
                        <RenderFields
                            fields={affiliationExist ?
                                [fields[2]] :
                                fields}
                        />
                    </div>
                    <div className='section-title'>פרטי המנהל</div>
                    <div className='section-fields'>
                        <RenderFields
                            fields={principalFields}
                        />
                    </div>
                    <div className='section-title'>פרטי איש קשר</div>
                    <div className='section-fields'>
                        <RenderFields
                            fields={contactFields}
                        />
                    </div>
                </CreateAffiliationStyles>
            </Form>
        </Alert>
    )
}

export default Affliation